var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal-field-list-view is-multiple-detail",
      attrs: { id: _vm.id }
    },
    [
      _c("div", { staticClass: "modal-title" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "wrap-type" }, [
          _c("img", {
            attrs: { src: require("@/assets/new-form-ui/text.svg") }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "text-type" }, [_vm._v(_vm._s(_vm.title))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "wrap-content" }, [
        _c(
          "div",
          { staticClass: "section-field input-field" },
          [
            _c("p", { staticClass: "title-section" }, [
              _vm._v("Parse Value To")
            ]),
            _vm._v(" "),
            _c(
              "b-form",
              { class: { "error-input": _vm.$v.dataSetup.variable.$error } },
              [
                _c("label", [_vm._v(" Variable ")]),
                _vm._v(" "),
                _c("j-single-select", {
                  attrs: {
                    options: _vm.options,
                    placeholder: "Select Variable",
                    label: "label"
                  },
                  model: {
                    value: _vm.dataSetup.variable,
                    callback: function($$v) {
                      _vm.$set(_vm.dataSetup, "variable", $$v)
                    },
                    expression: "dataSetup.variable"
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "d-flex justify-content-end mt-2" }, [
        _c(
          "button",
          {
            staticClass: "button-border mr-2",
            on: {
              click: function($event) {
                _vm.$emit("close-modal")
              }
            }
          },
          [_vm._v("\n      Close\n    ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button-blue",
            attrs: { disabled: !_vm.dataSetup.variable },
            on: { click: _vm.submitForm }
          },
          [_vm._v("\n      Apply\n    ")]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h4", { staticClass: "title" }, [
      _vm._v("\n      Properties\n      "),
      _c("div", { staticClass: "title-badge" }, [
        _vm._v("Field on Detail View")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-30d2b9f9", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d2b9f9","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/experience-manager-v2/popup/ModalTitleMultipleDetail.vue
// module id = null
// module chunks = 